import * as React from 'react'
import {maybe} from '@freckle/maybe'
import {Alert} from '@frontrow/console/src/components/ui/alert'

type CrmManagedEntity = 'district' | 'school'

/** @internal */
export type Props = {
  addClass?: string
  active: boolean
  crmId: string | undefined | null
  crmManagedEntity: CrmManagedEntity
  instructions?: string
}

export function CrmManagedAlert(props: Props): React.ReactElement {
  const noAlert = () => null

  const {addClass, active, crmId: mCrmId, crmManagedEntity, instructions} = props

  const renderAlertIfActive = (crmId: string) =>
    active ? (
      <Alert type="info" addClass={addClass} data-test="crm-managed-alert">
        {getAlertText(crmManagedEntity, crmId, instructions)}
      </Alert>
    ) : null

  return maybe(noAlert, renderAlertIfActive, mCrmId) ?? <></>
}

function getAlertText(
  crmManagedEntity: CrmManagedEntity,
  crmId: string,
  instructions?: string | null
): string {
  const directions =
    instructions !== null && instructions !== undefined
      ? instructions
      : 'To update this information, please make changes in the Renaissance system(s).'

  return `This ${crmManagedEntity} is managed in CRM (id #${crmId}). ${directions}`
}
